export default "__VITE_ASSET__nyQHaomqYz5Lo40$MRSdtQ__"